import React from "react";
import IncidentDashboard from "./components/IncidentDashboard";
import { WASHROOM_ISSUES_REPORTS } from "../../constants/modules";
import { fetchWashroomIncidentsByDepartment } from "./services/service";
import { IncidentDepartmentEnum } from "../../constants/incidents";

const WashroomManagementIncident: React.FC = () => (
  <IncidentDashboard
    department={IncidentDepartmentEnum.WashroomManagement}
    pageTitle="Incident Management"
    moduleKey={WASHROOM_ISSUES_REPORTS}
    fetchService={fetchWashroomIncidentsByDepartment}
  />
);

export default WashroomManagementIncident;
